module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_3.e1d80cc4.png";